<div id="indefiniteProgressDialog" 
    appDraggable dragTarget="#indefiniteProgressDialog" dragHandle="#indefiniteProgressDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle"
    role="dialog"
    tabindex="-999"
    >

    <div role="document" id="indefiniteProgressDialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="indefiniteProgressDialogHeader">
                <h4 class="modal-title">
                    <span>{{ title }}</span>
                </h4>
            </div>

			<div class="modal-body">
				<p> {{ message }} </p>
                <img src="assets/images/indefinite-progress.gif" class="img-responsive center-block" style="max-width: 120px; max-height: 120px" />
			</div>

            <div class="modal-footer">
            </div>

        </div>
    </div>

</div>